export const schreibenTasks = [
    {
        id: 1,
        title: "Aufgabe 1: Beschwerdebrief",
        situation: "Sie haben einen Intensivsprachkurs in Wien besucht. Leider waren Sie mit dem Kurs und der Unterbringung gar nicht zufrieden.",
        adPoints: [
            "Kleine Gruppen (max. 5 Personen)",
            "Modernes Sprachlabor & kostenloses Material",
            "Zentrale Unterkunft (Einzelzimmer)",
            "Abwechslungsreiches Freizeitprogramm"
        ],
        instructions: "Schreiben Sie eine Beschwerde an die Kursleitung. Behandeln Sie mindestens drei Punkte. Vergessen Sie nicht Anrede, Einleitung, Schluss und Grußformel. (Mind. 120 Wörter)",
        usefulPhrases: [
            "Ich schreibe Ihnen, um mich über ... zu beschweren.",
            "In Ihrer Anzeige stand, dass ..., aber in Realität ...",
            "Dies entsprach keineswegs meinen Erwartungen.",
            "Ich bin sehr enttäuscht darüber, dass ...",
            "Aus diesen Gründen erwarte ich eine angemessene Rückerstattung."
        ]
    }
];